import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Button from "../components/controls/Button";

export default function CookieConsent() {
  const [consent, setConsent] = useState(
    localStorage.getItem("analyticsConsent")
  );

  useEffect(() => {
    if (consent === "true") {
      loadAnalytics();
    }
  }, [consent]);

  const loadAnalytics = () => {
    if (
      window.gtag ||
      !["ananassolutions.ca", "ananassolutions.com"].includes(
        window.location.hostname
      ) //keeps this to exclude dev and test environments
    )
      return;
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-7NMLQ1HV16";
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "G-7NMLQ1HV16");
  };

  const handleAccept = () => {
    localStorage.setItem("analyticsConsent", "true");
    setConsent("true");
  };

  const handleDecline = () => {
    localStorage.setItem("analyticsConsent", "false");
    setConsent("false");
  };

  if (consent !== null) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:right-auto bg-white shadow-3xl border border-gray-200 rounded-xl p-4 md:max-w-md z-50">
      <p className="text-gray-700 text-sm mb-3">
        Nous utilisons des cookies pour améliorer votre expérience et analyser
        le trafic. Consultez nos{" "}
        <Link to="/privacy" className="text-[3a3a3a] underline">
          politiques de confidentialité
        </Link>{" "}
        et{" "}
        <Link to="/terms-and-conditions" className="text-[3a3a3a] underline">
          conditions d’utilisation
        </Link>
        .
      </p>
      <div className="flex justify-end gap-2">
        <Button
          onClick={handleDecline}
          color="coral"
          size="sm"
          className="border border-gray-300 text-sm"
        >
          Refuser
        </Button>
        <Button
          onClick={handleAccept}
          color="primary"
          size="sm"
          className="text-sm"
        >
          Accepter
        </Button>
      </div>
    </div>
  );
}
